import { lazy, Suspense } from "react";
import { Route } from "react-router-dom";

import HdPageLoader from "@hd/ui-kit/hd-page-loader/HdPageLoader";

const ConversationHubPage = lazy(
  () => import("./pages/conversation-hub/ConversationHubPage")
);

const ContactDetailPage = lazy(
  () => import("./pages/contact-detail/ContactDetailPage")
);
function usePersonsRoutes() {
  return (
    <>
      <Route
        path="conversation-hub/*"
        element={
          <Suspense fallback={<HdPageLoader />}>
            <ConversationHubPage />
          </Suspense>
        }
      />

      <Route
        path="contacts-edit/:id"
        element={
          <Suspense fallback={<HdPageLoader />}>
            <ContactDetailPage />
          </Suspense>
        }
      />
    </>
  );
}

export default usePersonsRoutes;
